import deploymentUrls from "../envs/deploymentConfigs";
import { azureADConfigsDEV, azureADConfigsPROD, azureADConfigsTEST, tokenClaimScope } from "./environmentConfigs";


let configurations;
let appRegScope;

const clientUrl = deploymentUrls.client;

if(process.env.REACT_APP_ENV === "developmentenv" || process.env.REACT_APP_ENV === "development" ){
    configurations = azureADConfigsDEV;
    appRegScope = tokenClaimScope.devEnvScope;
}

else if(process.env.REACT_APP_ENV === "test"){
    configurations = azureADConfigsTEST;
    appRegScope = tokenClaimScope.testEnvScope;
}

else if(process.env.REACT_APP_ENV === "production"){
    configurations = azureADConfigsPROD;
    appRegScope = tokenClaimScope.prodEnvScop;
}
else{
    configurations = azureADConfigsDEV;
    appRegScope = tokenClaimScope.devEnvScope;
}

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId:  configurations.clientId,
        authority: configurations.authority,
        postLogoutRedirectUri: clientUrl,
        redirectUri: clientUrl,
        knownAuthorities: configurations.knownAuthorities,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ["openid", "profile"]
  };

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const apiScopeConfig = {
    apiScope: appRegScope
}
